import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { inboxGridItemFrag } from './types/inbox.gql-types';
import { InboxGridObject } from '@libs/types/src/inbox/object-type/inbox.object';
import { filterFrag } from '../../../services/types/filter.types';
import { InboxCreateInput } from '@libs/types/src/inbox/input-type/inbox.create-input';
import { InboxUpdateInput } from '@libs/types/src/inbox/input-type/inbox.update-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';

@Injectable({ providedIn: 'root' })
export class InboxGqlService extends GqlServiceV2 {

    getDataboxInboxes(input: GridInput, frag: string = inboxGridItemFrag) {
        return this.query<InboxGridObject>(
            `
                query($input: GridInput!) {
                    inbox {
                        filterDataboxInboxes(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    getDmsInboxes(input: GridInput, frag: string = inboxGridItemFrag) {
        return this.query<InboxGridObject>(
            `
                query($input: GridInput!) {
                    inbox {
                        filterDmsInboxes(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    getEmailInboxes(input: GridInput, frag: string = inboxGridItemFrag) {
        return this.query<InboxGridObject>(
            `
                query($input: GridInput!) {
                    inbox {
                        filterEmailInboxes(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    createDatabox(input: InboxCreateInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxCreateInput!) {
                inbox {
                    createDatabox(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    createDms(input: InboxCreateInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxCreateInput!) {
                inbox {
                    createDms(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    updateDatabox(input: InboxUpdateInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxUpdateInput!) {
                inbox {
                    updateDatabox(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    updateDms(input: InboxUpdateInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxUpdateInput!) {
                inbox {
                    updateDms(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    restoreDatabox(input: IdInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: IdInput!) {
                inbox {
                    restoreDatabox(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    restoreDms(input: IdInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: IdInput!) {
                inbox {
                    restoreDms(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    deleteDms(input: IdInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: IdInput!) {
                inbox {
                    deleteDms(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    deleteDatabox(input: IdInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: IdInput!) {
                inbox {
                    deleteDatabox(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }
}
